import { IPAPI_API_KEY } from './utils'
type Data = {
  query: string // IP ADDRESS
  timezone: string
  city: string
  region: string
  regionName: string
  country: string
  countryCode: string
  zip: string
  // continent_name: string
  // continent_code: string
  lat: string
  lon: string
  // flag: string
  isp: string
  org: string
  as: string
  emoji_flag: string
}
export default async function getIpData() {
  // const data: Data = await fetch(`https://api.ipdata.co/?api-key=${IP_DATA_API_KEY}`).then(
  const data: Data = await fetch(`https://pro.ip-api.com/json?key=${IPAPI_API_KEY}`).then(
    (response) => response.json()
  )
  console.log('IP-API data:', data)
  // const geohash = encodeAsGeohash(latitude, longitude)
  const locationData = {
    ip: data?.query,
    timezone: data?.timezone,
    city: data?.city,
    region: data?.regionName,
    region_code: data?.region,
    country_name: data?.country,
    country_code: data?.countryCode,
    zip: data?.zip,
    // continent_name: data?.continent_name,
    // continent_code: data?.continent_code,
    latitude: data?.lat,
    longitude: data?.lon,
    isp: data?.isp,
    org: data?.org,
    as: data?.as,
    // flag: data?.flag,
    emoji_flag: data?.emoji_flag,
    // geohash,
  }
  Object.entries(locationData).forEach((e) => {
    if (e[1] === undefined || e[1] === null) delete locationData[e[0]]
  })
  return locationData
}
// // Got this from https://stackoverflow.com/questions/49136896/geohash-16-how-to
// // No idea if it works
// function encodeAsGeohash(latitude, longitude) {
//   var BASE16_CODES = '0123456789abcdef' // <-- changed this
//   var BASE16_CODES_DICT = {}
//   for (var i = 0; i < BASE16_CODES.length; i++) {
//     BASE16_CODES_DICT[BASE16_CODES.charAt(i)] = i
//   }
//   var ENCODE_AUTO = 'auto'
//   var SIGFIG_HASH_LENGTH = [0, 5, 7, 8, 11, 12, 13, 15, 16, 17, 18]
//   var encode = function (latitude, longitude, numberOfChars) {
//     if (numberOfChars === ENCODE_AUTO) {
//       if (typeof latitude === 'number' || typeof longitude === 'number') {
//         throw new Error('string notation required for auto precision.')
//       }
//       var decSigFigsLat = latitude.split('.')[1].length
//       var decSigFigsLong = longitude.split('.')[1].length
//       var numberOfSigFigs = Math.max(decSigFigsLat, decSigFigsLong)
//       numberOfChars = SIGFIG_HASH_LENGTH[numberOfSigFigs]
//     } else if (numberOfChars === undefined) {
//       numberOfChars = 12 // <-- and this
//     }
//     var chars = [],
//       bits = 0,
//       bitsTotal = 0,
//       hash_value = 0,
//       maxLat = 90,
//       minLat = -90,
//       maxLon = 180,
//       minLon = -180,
//       mid
//     while (chars.length < numberOfChars) {
//       if (bitsTotal % 2 === 0) {
//         mid = (maxLon + minLon) / 2
//         if (longitude > mid) {
//           hash_value = (hash_value << 1) + 1
//           minLon = mid
//         } else {
//           hash_value = (hash_value << 1) + 0
//           maxLon = mid
//         }
//       } else {
//         mid = (maxLat + minLat) / 2
//         if (latitude > mid) {
//           hash_value = (hash_value << 1) + 1
//           minLat = mid
//         } else {
//           hash_value = (hash_value << 1) + 0
//           maxLat = mid
//         }
//       }
//       bits++
//       bitsTotal++
//       if (bits === 4) {
//         // <-- and finally this
//         var code = BASE16_CODES[hash_value]
//         chars.push(code)
//         bits = 0
//         hash_value = 0
//       }
//     }
//     return chars.join('')
//   }
//   return encode(latitude, longitude)
// }
